// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4044":"f4a30a50","5191":"fb753bf9","9125":"f11ab9d5"}[chunkId] + ".chunk.css";
};